import useClipboard from "@/hooks/useClipboard";
import { BASE_URL } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { useChat } from "@/providers/chat-provider";
import { ArrowLeftIcon, LockIcon, Share2Icon, Users2Icon } from "lucide-react";

const ChatHeader = () => {
	const { isCopied, handleCopy } = useClipboard();
	const { activeChat, handleOpenInbox } = useChat();

	return (
		<div className="border-b border-gray-100 p-2.5">
			<div className="flex items-center justify-between gap-2 rounded-md bg-brand-primary px-4 py-2 text-white">
				<div className="flex items-center gap-2">
					<button type="button" onClick={handleOpenInbox} aria-label="Go back to inbox">
						<ArrowLeftIcon className="h-5 w-5" />
					</button>

					<div>
						<div className="flex items-center justify-start gap-2">
							{/* Chat title */}
							<h5
								className="line-clamp-1 text-lg font-semibold capitalize"
								title={activeChat?.recipient?.name || "Chat"}
							>
								{activeChat?.recipient?.name || "Chat"}
							</h5>

							{activeChat?.type === "group" && !activeChat?.rules?.isVIPChat ? (
								<div className="flex items-center gap-1 rounded-full bg-red-50 px-2 py-1">
									<div className="h-2 w-2 animate-pulse rounded-full bg-red-500" />

									<span className="w-fit text-xxs font-medium text-red-900">Live</span>
								</div>
							) : activeChat?.type === "direct" ? (
								<div
									className={cn(
										"flex items-center gap-1 rounded-full px-2 py-1",
										activeChat?.online ? "bg-green-50" : "bg-gray-50"
									)}
								>
									<div
										className={cn(
											"h-2 w-2 rounded-full",
											activeChat?.online ? "bg-green-500" : "bg-gray-300"
										)}
									/>

									<span className="w-fit text-xxs font-medium text-green-900">
										{activeChat?.online ? "Online" : "Away"}
									</span>
								</div>
							) : null}
						</div>

						{/* Chat type */}
						<div className="mt-1 flex items-center justify-start gap-0.5 text-xxs font-medium">
							{activeChat?.type === "direct" || activeChat?.rules?.isVIPChat ? (
								<LockIcon className="h-3 w-3" />
							) : (
								<Users2Icon className="h-3 w-3" />
							)}

							<p>
								{activeChat?.type === "direct" || activeChat?.rules?.isVIPChat
									? "Private chat stream"
									: "Public community chat stream"}
							</p>
						</div>
					</div>
				</div>

				{/* Chat actions */}
				{activeChat?.type === "group" && activeChat.rules?.isVerifiedChat ? (
					<button
						type="button"
						className="relative"
						aria-label="Share Chat Link"
						onClick={() => handleCopy(`${BASE_URL}/chat?chatId=${activeChat.uniqueChatId}`)}
					>
						<Share2Icon className="h-5 w-5 text-white md:h-5 md:w-5" />

						{isCopied ? (
							<div className="absolute bottom-0 left-[-72px] rounded-lg border bg-white px-3 py-1 text-xs font-medium text-brand-primary">
								Copied
							</div>
						) : null}
					</button>
				) : null}
			</div>
		</div>
	);
};

export default ChatHeader;
